<template>
    <div class="model-list">
        <el-header height="35px"><font size="5"  color="#009900"><B>模型列表</B></font> </el-header>
        <div class="model-item"
            v-for="(model, index) in modelList"
            :key="model.id"
            :class="{'selected': model.selected}"
            @click="handleTaskSelected(index)"> 
            <div class="model-select-tag"></div>
            <div class="model-content">
                <span class="model-title">{{model.modelName}}</span>
                <!-- <span class="model-title2">{{model.processDefinitionKey}}</span>
                <span class="define-key">{{model.assignee ? model.assignee.trueName : ''}}</span> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                selectTask: {}
            };
        },
        props: {
            modelList: {
                type: Array
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                this.modelList.forEach((element, i) => {
                    this.$set(this.modelList[i], 'selected', false);
                });
                this.modelList.length > 0 && (this.handleTaskSelected(0));
            },
            async handleTaskSelected (index) {
                for (let i = 0, len = this.modelList.length; i < len; i++) {
                    if (this.modelList[i].selected === true) {
                        this.modelList[i].selected = false;
                        break;
                    }
                }
                this.modelList[index].selected = true;
                this.$emit('selected', this.modelList[index]);
            }
        }
    };
</script>

<style lang="less">
    .model-list {
        height: 100%;
        width: 100%;
        border-right: 1px solid #d8dce5;

        display: flex;
        flex-direction: column;

        .model-item {
            height: 40px;
            padding: 3px;
            cursor: pointer;
            // border-top: 1px solid #FFFFFF;
            border-bottom: 1px solid rgb(241, 241, 241);
            flex-shrink:0;
            display: flex;
            // flex-direction: column;
        }
        .model-item.selected {
            .model-select-tag {
                background-color: rgb(46, 150, 185);
            }
            // border-top: 1px solid rgb(241, 241, 241);
            // border-bottom: 1px solid rgb(241, 241, 241);
            background: rgb(255, 255, 255);
        }
        .model-item:hover {
            // border-top: 1px solid rgb(241, 241, 241);
            // border-bottom: 1px solid rgb(241, 241, 241);
            // background: rgb(255, 255, 255);
            background-color: #ecf5ff;
        }
        .model-select-tag {
            width: 5px;
            height: 100%;
            // background-color: rgb(46, 150, 185);
        }

        .model-content {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            color: #00CC00;
            margin: 0 0 0 4px;
            height: 100%;
        }
        .model-title {
            font-size: 16px;
            color: #00000041
        }
        .model-title2 {
            font-size: 12px;
            color: #00000041
        }

        .define-key {
            font-size: 12px;
            color: #d9e1f3
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/ModelList.vue